import React from 'react';
import { Link } from 'react-router-dom';

const SingleFarmar = (props) => {

    return (
        <div>
            <Link to="">
              <div className="farmer-info">
                <div className="farmer-img">
                  <img style={{width:"260px",height:'250px',objectFit:'cover'}}
                    src={props.info.photoUrl}
                    alt=""
                  />
                </div>
                <div className="farmer-basic">
                  <h3>{props.info.fName} {props?.info?.lName}</h3>
                  <p>Lead Farmer</p>
                  <div className="farmer-social">
                    <div className="social-icon">
                      <ul className="d-flex list-group flex-row justify-content-center gap-2 ">
                        <li>
                          <svg
                            style={{ width: "30px" }}
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
                            />
                          </svg>
                        </li>
                        <li>
                          <svg
                            style={{ width: "30px" }}
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                             
                              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                            />
                          </svg>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
        </div>
    );
};

export default SingleFarmar;